module.exports = __webpack_public_path__ + "media/Instrumental.b2220ead.mp3";